import { render, staticRenderFns } from "./Template-06.vue?vue&type=template&id=28f3f05a&scoped=true&"
import script from "./Template-06.vue?vue&type=script&lang=js&"
export * from "./Template-06.vue?vue&type=script&lang=js&"
import style0 from "./Template-06.vue?vue&type=style&index=0&id=28f3f05a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3f05a",
  null
  
)

export default component.exports